import { ACTIONS_NAMESPACE } from '../constants';

export const MOUNT_POINT = 'case';

export const SET_LAST_OPENED = `${ACTIONS_NAMESPACE}/SET_LAST_OPENED`;
export const REMOVE_LAST_OPENED = `${ACTIONS_NAMESPACE}/REMOVE_LAST_OPENED`;
